import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ResourceAvailabilityService', ResourceAvailabilityService);

  ResourceAvailabilityService.$inject = [
    'RestResource',
    '$translate',
    'UtilService',
    'WindowModalService',
  ];

  function ResourceAvailabilityService(RestResource, $translate, UtilService, WindowModalService) {
    const utils = new UtilService(this);

    const apiUrl = environment.apiEndpoint + 'resources';

    const service = {
      getFilterCriteria: getFilterCriteria,
      getResourceAvailabilities: getResourceAvailabilities,
      openResourceAvailabilityListModal: openResourceAvailabilityListModal,
      openResourceAvailabilityDetailModal: openResourceAvailabilityDetailModal,
      saveResourceAvailability: saveResourceAvailability,
      changeResourceAvailabilityStatus: changeResourceAvailabilityStatus,
      deleteResourceAvailability: deleteResourceAvailability,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      const filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'start_date',
      };

      return filterCriteria;
    }

    function getResourceAvailabilities(resourceId, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      let url = `${apiUrl}/${resourceId}/resource_availabilities`;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function openResourceAvailabilityListModal(resource) {
      let templateUrl =
        './app/ajs/resources/resource-availabilities/modals/resource-availability-list-modal.html';

      let modalParams = {
        title:
          resource.resource_contact.name +
          ' ' +
          resource.resource_contact.last_name +
          ' - ' +
          $translate.instant('RESOURCE_AVAILABILITY'),
        item: resource,
        // preventModalClose: true
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function openResourceAvailabilityDetailModal(resourceAvailability, resource, successCallback) {
      // lastResourceAvailability
      let templateUrl =
        './app/ajs/resources/resource-availabilities/modals/resource-availability-detail-modal.html';

      let originalItem = angular.copy(resourceAvailability);

      let modalParams = {
        title: !resourceAvailability.id ? 'ADD_AVAILABILITY' : 'EDIT_AVAILABILITY',
        item: originalItem,
        // mode:  mode,
        additionalParams: {
          resource: resource,
          // lastResourceAvailability: lastResourceAvailability
        },
        preventModalClose: true,
      };

      // , mode
      // if (!resource.id){
      //     modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      let confirmCallback = function (response) {
        if (resourceAvailability.id) {
          // edit
          resourceAvailability.start_date = response.start_date;
          resourceAvailability.end_date = response.end_date;
          resourceAvailability.all_day = response.all_day;
          resourceAvailability.start_time = response.start_time;
          resourceAvailability.end_time = response.end_time;
          resourceAvailability.on_monday = response.on_monday;
          resourceAvailability.on_tuesday = response.on_tuesday;
          resourceAvailability.on_wednesday = response.on_wednesday;
          resourceAvailability.on_thursday = response.on_thursday;
          resourceAvailability.on_friday = response.on_friday;
          resourceAvailability.on_saturday = response.on_saturday;
          resourceAvailability.on_sunday = response.on_sunday;

          return utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function saveResourceAvailability(resourceAvailability, resource_id) {
      let method;
      let url = `${apiUrl}/${resource_id}/resource_availabilities`;

      if (!resourceAvailability.id) {
        // create
        method = 'post';
      } else {
        method = 'put';
        url += '/' + resourceAvailability.id;
      }

      return RestResource.request(
        method,
        url,
        { resource_availability: resourceAvailability },
        function (response) {
          let msg = !resourceAvailability.id ? 'AVAIABILITY_ADDED' : 'AVAIABILITY_UPDATED';
          utils._successMsg($translate.instant(msg));

          return response.data;
        },
        function (response) {
          return response.data;
          // return false;
        }
      );
    }

    function changeResourceAvailabilityStatus(resourceAvailability) {
      // utils.changeItemStatus(apiUrl +'/'+ resource.id, resource);
      // let newStatus = !resource.status;
      // let url = apiUrl +'/'+ resourceAvailability.resource_id +'/resource_availabilities/'+ resourceAvailability.id +'?set_status=true';

      let url = `${apiUrl}/${resourceAvailability.resource_id}/resource_availabilities/${resourceAvailability.id}?set_status=true`;

      let params = {
        check_if_used: true,
        status: !resourceAvailability.status,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, resourceAvailability);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function deleteResourceAvailability(resourceAvailability, successCallback) {
      let url = `${apiUrl}/${resourceAvailability.resource_id}/resource_availabilities/${resourceAvailability.id}`;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_AVAIABILITY',
            confirmButtonLabel: 'CONFIRM',
            body: 'DELETE_AVAIABILITY_MSG',
            successMsg: 'AVAIABILITY_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }
  }
})();
